<template>
  <div>
    <div class="app-head">
      <div>
        <h4 class="app-title">编辑学习资源</h4>
        <div class="app-desc">编辑并发布学习资源。</div>
      </div>
      <div>
        <router-link to="/course-list">返回学习资源列表</router-link>
      </div>
    </div>
    <div class="app-form">
      <div class="">
        <el-form ref="form" :model="editData" :rules="rules" label-width="140px" v-loading="loading">
          <el-form-item label="分类" prop="cateid">
            <el-select v-model="editData.cateid" v-loading="loading.coursecate">
              <el-option v-for="item in coursecateList" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源（课程）名称" prop="title">
            <el-input v-model="editData.title"></el-input>
          </el-form-item>
          <el-form-item label="题图" prop="tel">
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :on-remove="handleRemove"
              :limit="1"
              list-type="picture"
              ref="upload">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5MB</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="选项">
            <el-switch
              v-model="editData.istop"
              active-text="置顶"
            />
          </el-form-item>
          <el-form-item label="视频地址" prop="video">
            <el-input v-model="editData.video"></el-input>
          </el-form-item>
          <el-form-item label="上课教师" prop="teacher">
            <el-input v-model="editData.teacher"></el-input>
          </el-form-item>
          <el-form-item label="学时" prop="minute">
            <el-input v-model.number="editData.minute">
              <span slot="suffix">分钟</span>
            </el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content" class="textarea">
            <JyEditor :content="editData.content" @blur="upateContent" :params="editData" :uploadHeaders="headers"
              :uploadParams="{isEditor:'true'}" :uploadImgUrl="uploadPic" :imgOnLoad="editImgOnLoad" has-code />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="!hasPermiss('weborg.course.edit')" @click="onSubmit('form')" :loading="saveLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import JyEditor from 'jycomponents/editor/main';
export default {
  mixins: [tools],
  components: { JyEditor },
  props: ['id'],
  data () {
    return {
      loading: false,
      editData: {},
      rules: {
        title: { required: true, message: '请输入图文标题', trigger: 'blur' },
        minute: { required: true, type:'integer', min:0, message: '请输入正确的学时(分钟)', trigger: 'blur' },
      },
      saveLoading: false,
      fileList: [],
      editImgs: []
    }
  },
  computed: {
    ...mapGetters({
      coursecateList: [types.BASE_LOAD.coursecateList],
      baseLoading: [types.BASE_LOAD.baseLoading]
    }),
    defaultData() {
      return {
        title:'', content:'', pic:null, minute:null, istop:false, teacher:null, video:null
      }
    }
  },
  watch: {
    id() {
      this.getData();
    }
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.coursecateList || !this.coursecateList.length) {
      this.$store.dispatch(types.BASE_LOAD.coursecateList);
    }
    if (!this.editData.id) {
      this.getData();
    }
  },
  methods: {
    getData() {
      if (this.loading || !this.hasPermiss('weborg.course.query')) {
        return;
      }
      this.loading = true;
      if (this.id) {
        this.doGet({
          url: 'vue/organization/course/'+ this.id,
          okcb: (json) => {
            this.editData = Object.assign({}, json);
            this.editImgs = [];
            this.fileList = [];
            if (this.editData.pic) {
              this.fileList.push({name: this.editData.pic, url: this.rootPath + this.editData.pic});
            }
          },
          cb: () => {
            this.$nextTick(() => this.loading = false);
          }
        });
      } else {
        this.editData = Object.assign({}, this.form, this.defaultData);
        this.fileList = [];
        this.loading = false;
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    },
    handleUploadSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.pic = res.obj.pic;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    handleRemove() {
      this.editData.pic = null;
    },
    editImgOnLoad(json, insertImg, e) {
      if (json && json.obj && json.obj.pic) {
        let src = json.obj.pic;
        this.editImgs.push(src);
        src = this.rootPath + src;
        insertImg(src);
      }
    },
    upateContent(html, obj) {
      obj.content = html;
    },
    onSubmit(formName) {
      this.submitform(formName).then(() => {
        this.saveLoading = true;
        this.doPost({
          url: 'vue/organization/course/save',
          data: this.editData,
          okcb: (json) => {
            this.$message.success('保存成功！');
            this.editImgs = [];
            this.$router.push('/course-list');
            this.$store.commit(types.ORGANIZATION.reloadCourse);
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      }).catch(() => {

      });
    },
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    margin-bottom:2rem;
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
  &-form {
    margin-top:2rem;
    padding:2rem;
    background-color:#fff;
    .shadow-black(0 0 6px 0, .03);
    form {
      .el-form-item {
        max-width:600px;
        &.textarea {
          max-width:1000px;
        }
      }
    }
  }
}
</style>